<template>
    <div v-if="isLoggedIn">
        <span :class="['icon-lock', { 'vertical': isVertical }]" v-tooltip="{ content: $t('TotemLockIcon.tooltip_info'), html: true }" @click.stop.prevent="goToUrl()"></span>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'totem-lock-icon',
        props: {
            isVertical: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            goToUrl () {}
        },
        computed: {
            ...mapGetters({
                isLoggedIn: 'isLoggedIn'
            })
        }
    }
</script>

<style lang="scss" scoped>
    .icon-lock {
        position: absolute;
        top: 10px;
        right: 10px;
        background: $chestnut;
        border-radius: 100%;
        width: 30px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1;

        &:before {
            color: $white;
            font-size: 2.1rem;
        }

        &.vertical {
            top: unset;
            bottom: 27px;
            right: 27px;
            width: 24px;
            height: 24px;

            &:before {
                font-size: 1.6rem;
            }

            [class*="mobile"] & {
                top: 10px;
                right: 10px;
                bottom: unset;
            }
        }
    }
</style>
